import { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { getServicesByCategory, SERVICE_CATEGORIES } from "../lib/serviceCatalog";

export default function ServiceCategoryNav() {
  const [openCategory, setOpenCategory] = useState(null);
  const menuGridClass = {
    Startup: "sm:w-[38rem] sm:grid-cols-2 sm:grid-flow-col sm:grid-rows-5",
    Registrations: "sm:w-[48rem] sm:grid-cols-2 lg:w-[78rem] lg:grid-cols-4 lg:grid-flow-col lg:grid-rows-7",
    Trademark: "md:w-[58rem] md:grid-cols-3 md:grid-flow-col md:grid-rows-6",
    GST: "sm:w-[48rem] sm:grid-cols-2 sm:grid-flow-col sm:grid-rows-5",
    "Income Tax": "sm:w-[48rem] sm:grid-cols-2 sm:grid-flow-col sm:grid-rows-5",
    MCA: "md:w-[58rem] md:grid-cols-3 md:grid-flow-col md:grid-rows-7",
    Compliance: "sm:w-[48rem] sm:grid-cols-2 sm:grid-flow-col sm:grid-rows-7",
  }[openCategory] || "sm:w-80";

  return (
    <nav
      aria-label="Service categories"
      className="relative order-3 z-10 w-full bg-white min-[960px]:order-2 min-[960px]:w-auto min-[960px]:min-w-0 min-[960px]:flex-1"
      data-testid="service-category-navigation"
      onKeyDown={(event) => {
        if (event.key === "Escape") setOpenCategory(null);
      }}
    >
      <div className="flex min-w-0 gap-0 overflow-x-auto px-3 sm:px-6 min-[960px]:justify-center min-[960px]:overflow-visible min-[960px]:px-0">
        {SERVICE_CATEGORIES.map(({ name }) => (
          <button
            key={name}
            type="button"
            aria-expanded={openCategory === name}
            aria-controls={`service-category-menu-${name.toLowerCase().replaceAll(" ", "-")}`}
            onClick={() => setOpenCategory((current) => current === name ? null : name)}
            className="flex shrink-0 cursor-pointer items-center gap-1 px-2 py-3 text-xs font-medium text-slate-700 outline-none transition-colors hover:text-[#C83D43] focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#C83D43] min-[960px]:gap-0.5 min-[960px]:px-0.5 min-[960px]:text-[11px]"
              data-testid={`category-${name.toLowerCase().replaceAll(" ", "-")}`}
          >
              {name}
              <CaretDown
                size={14}
                className={`transition-transform duration-150 ${openCategory === name ? "rotate-180" : ""}`}
                aria-hidden="true"
              />
          </button>
        ))}
      </div>
      {openCategory && (
        <div
          id={`service-category-menu-${openCategory.toLowerCase().replaceAll(" ", "-")}`}
          className={`absolute left-0 top-full z-30 grid max-h-[75vh] w-[calc(100vw-1.5rem)] max-w-[calc(100vw-1.5rem)] grid-cols-1 content-start overflow-y-auto border border-slate-200 bg-white py-2 shadow-lg ${menuGridClass}`}
          data-testid="service-category-menu"
        >
          {getServicesByCategory(openCategory).map((service) => (
            <Link
              key={service.slug}
              to={`/services/${service.slug}`}
              onClick={() => setOpenCategory(null)}
              className="block px-4 py-2.5 text-sm text-slate-700 transition-colors hover:bg-slate-50 hover:text-[#C83D43] focus-visible:bg-slate-50 focus-visible:outline-none"
              data-testid={`category-link-${service.slug}`}
            >
              {service.menuTitle || service.title}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
